import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { CoachService } from '../services/coach.service';
import { ErrorService } from '../services/error.service';
import * as Global from 'src/app/global';

@Component({
  selector: 'app-school-dashboard-layout',
  templateUrl: './school-dashboard-layout.component.html',
  styleUrls: ['./school-dashboard-layout.component.scss'],
})
export class SchoolDashboardLayoutComponent implements OnInit {
  schoolDetails: any = this.authService.getSchoolSessionDetails();
  Global = Global;
  PageTitle: any;
  notifications: any = [];
  notificationCount: number = 0;
  apiCalling: boolean = false;
  apiCalled: boolean = false;
  show_notification: boolean = false;
  profile_image: string = '';
  base_route: string = '';
  titleRed: boolean = false;
  constructor(
    private authService: AuthService,
    private coachService: CoachService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private errorService: ErrorService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.mobMenu = false;
        let route = this.router.url.split('/')[2] ?? '';
        if (route == 'dashboard') {
          this.PageTitle = `Dashboard`;
        }
      }
    });
  }

  ngOnInit(): void {}

  mobMenu: boolean = false; // hidden by default
  toggleMobMenu() {
    this.mobMenu = !this.mobMenu;
  }

  fetchNotificationCount() {
    return new Promise((resolve, reject) => {
      this.coachService.countNotification({}).subscribe(
        (res) => {
          const data = res.data;

          if (data.current_status != 'A') {
            // this.router.navigateByUrl('/login');
            this.authService.coachLogout();
            this.toastr.error('Your account has been blocked by admin');
          }
          // console.log(res);
          if (res.status == 'success') {
            this.notificationCount = Number(data?.notification_count)
              ? data?.notification_count
              : 0;
            this.show_notification = true;
            resolve(true);
          } else {
            this.show_notification = true;

            // this.toastr.error(res.message);
            this.notificationCount = 0;
            reject(res.message);
          }
        },
        (err) => {
          this.notificationCount = 0;
          this.show_notification = false;
          this.errorService.showError(err);
          //reject(Global.getServerErrorMessage(err));
          this.spinner.hide();
        }
      );
    });
  }
  fetchNotifications() {
    return new Promise((resolve, reject) => {
      this.coachService.fetchNotifications({ page: 1, limit: 5 }).subscribe(
        (res) => {
          const data = res.data;
          console.log(res);
          this.apiCalling = false;
          this.apiCalled = true;
          if (res.status == 'success') {
            this.notifications = res.data.docs;
            resolve(true);
          } else {
            // this.toastr.error(res.message);
            this.notifications = [];
            reject(res.message);
          }
        },
        (err) => {
          this.notifications = [];
          this.errorService.showError(err);
          reject(Global.getServerErrorMessage(err));
        }
      );
    });
  }
  navigateToNotification() {
    // navigateToNotifications
    this.coachService.navigateToNotifications.next(true);
    this.router.navigate(['settings'], {
      queryParams: { tab: 'notifications' },
    });
  }
}
